import React from "react";
import { Container } from "react-bootstrap";
import Link from "../components/Link";
import WpImage from "../components/WpImage";
import NotchedOutline, { NotchArrowIcon } from "../components/NotchedOutline";

const SolutionCard = ({ icon, title, description, link }) => {
    return (
        <Link
            link={link}
            className="solution-cards__card"
            title={link?.title || title}
        >
            <NotchedOutline block="solution-cards" />

            <span className="solution-cards__body">
                {icon && (
                    <span className="solution-cards__icon">
                        <WpImage image={icon} alt="" />
                    </span>
                )}
                {title && (
                    <span className="solution-cards__title">{title}</span>
                )}
                {description && (
                    <span className="solution-cards__text">{description}</span>
                )}
            </span>

            <span className="solution-cards__arrow">
                <NotchArrowIcon />
            </span>
        </Link>
    );
};

const SolutionCards = ({ category, header, items, className }) => {
    const cards = items?.filter(({ title, link }) => title && link?.url) || [];

    if (cards.length === 0) return null;

    return (
        <section className={`solution-cards ${className || ""}`}>
            <Container>
                {(category || header) && (
                    <div className="solution-cards__intro">
                        {category && (
                            <p
                                className="solution-cards__label"
                                dangerouslySetInnerHTML={{ __html: category }}
                            />
                        )}
                        {header && (
                            <h2
                                className="solution-cards__header"
                                dangerouslySetInnerHTML={{ __html: header }}
                            />
                        )}
                    </div>
                )}

                <div className="solution-cards__grid">
                    {cards.map((card, index) => (
                        <SolutionCard key={index} {...card} />
                    ))}
                </div>
            </Container>
        </section>
    );
};

export default SolutionCards;
